import type {
  AnyObj,
  EmptyObj,
} from '@repo/internal-tools-type-utils/src/primitives.ts'

export type CheckIsObjEmptyOptions = {
  /**
   * If all values are `undefined`, the object is considered empty.
   */
  ignoreUndefined?: boolean
}

export const checkIsObjEmpty = <O extends AnyObj>(
  obj: O,
  options?: CheckIsObjEmptyOptions,
): obj is EmptyObj<keyof O> => {
  return (
    Object.keys(obj).length === 0 ||
    (options?.ignoreUndefined
      ? Object.values(obj).every((value) => value === undefined)
      : false)
  )
}
